var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.19282 1.7461C9.46165 1.48907 9.46165 1.07345 9.19282 0.81915C8.92399 0.564853 8.48929 0.562118 8.22332 0.81915L4.82007 4.07306L1.41397 0.816415C1.14514 0.559384 0.710439 0.559384 0.444471 0.816415C0.178503 1.07345 0.175643 1.48907 0.444471 1.74337L3.84772 4.99727L0.441611 8.25391C0.172783 8.51095 0.172783 8.92657 0.441611 9.18087C0.710439 9.43516 1.14514 9.4379 1.41111 9.18087L4.81435 5.92696L8.22046 9.1836C8.48929 9.44063 8.92399 9.44063 9.18996 9.1836C9.45593 8.92657 9.45879 8.51095 9.18996 8.25665L5.78671 5.00274L9.19282 1.7461Z",
    fill: "#A80000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossButton);
export default __webpack_public_path__ + "static/media/CrossButton.d591d2a31f49c0b29ae2642478840d40.svg";
export { ForwardRef as ReactComponent };